import React from "react";
import { useTranslation } from "../../context/TranslationContext";

const PaytheDoor = () => {
  const { ptdTitle1, ptdTitle2, ptdTitle3, ptdP1, ptdP2, ptdP3 } =
    useTranslation();
  return (
    <div className="container lg:py-32 py-16">
      <div className="flex lg:flex-nowrap flex-wrap lg:items-start items-center lg:justify-start justify-center">
        <div className="lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center lg:mb-0 mb-6">
          <img
            src="/images/kapi-odeme.png"
            className="object-contain w-[41.563rem] sm:h-[29.313rem] h-[12.5rem]"
          ></img>
        </div>
        <div className="lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center lg:text-start text-center">
          <div className="flex flex-col w-full  sm:pl-12">
            <div className="flex flex-wrap lg:flex-col lg:items-start items-center lg:justify-start justify-center  mb-8">
              <div className="flex items-center">
                <span className=" text-primary font-bold sm:text-[2.875rem] text-[1.875rem]">
                  {ptdTitle1}
                </span>
                <span className="font-bold text-dark sm:text-[2.875rem] text-[1.875rem] leading-[2.875rem]">
                  {ptdTitle2}
                </span>
              </div>
              <span className="font-bold text-dark sm:text-[2.875rem] text-[1.875rem] leading-[2.875rem]">
                {ptdTitle3}
              </span>
            </div>
            <div className="flex flex-col fon-normal text-15 opacity-50">
              <p className="mb-4">
                <strong>{process.env.NEXT_PUBLIC_SITENAME}</strong> {ptdP1}
              </p>
              <p className="mb-4">
                <strong>{ptdP2}</strong>
              </p>
              <p className="mb-4">
                {ptdP3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaytheDoor;
